/* eslint-disable import/extensions,import/no-unresolved,react/prefer-stateless-function,import/no-duplicates,import/no-named-as-default-member */

import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import {
  Route,
  Switch,
  withRouter,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import LoginPage from 'containers/Login/Loadable';
import NotFoundPage from 'containers/NotFoundPage/Loadable';
import FastCoverWizardPage from 'containers/FastCover/Loadable';
import ClaimListPage from 'containers/ClaimList/Loadable';
import PrivateRoute from 'containers/PrivateRoute';
import routeConfig from 'utils/routeConfig';
import ProgressBar from 'containers/ProgressBar';
import Notification from 'containers/Toastr';
import SummaryScreen from '../SummaryScreen';
import PostSubmit from '../PostSubmit/Loadable';
import ClaimAssessment from '../ClaimAssessment/Loadable';
import PostSubmitSCTI from '../PostSubmitSCTI/Loadable';
import { validateVerificationCodeRequest } from './actions';
import appSaga from './saga';
import injectSaga from 'utils/injectSaga';
import { connect } from 'react-redux';

const AppWrapper = styled.div`
  max-width: 852px;
  margin: 0 auto;
  display: flex;
  // min-height: 100%;
  padding: 0 16px;
  flex-direction: column;
`;

class App extends React.Component {
  constructor(props) {
    super(props);
    this.lastValidatedParams = null;
    this.checkAndValidateSSOParams(props);
  }

  componentDidMount() {
    this.checkAndValidateSSOParams(this.props);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.checkAndValidateSSOParams(this.props);
    }
  }

  checkAndValidateSSOParams(props) {
    const query = new URLSearchParams(props.location.search);
    const token = query.get('token');
    const verificationCode = query.get('verificationCode');
    const policyNumber = query.get('policyNumber');
    // Support both 'email' and 'emailAddress' query parameters
    const email = query.get('email') || query.get('emailAddress');

    // Create a unique key for these params to prevent duplicate validation calls
    const paramsKey = token && verificationCode && policyNumber && email
      ? `${token}-${verificationCode}-${policyNumber}-${email}`
      : null;

    if (paramsKey && !props.isAuthenticated && this.lastValidatedParams !== paramsKey) {
      this.lastValidatedParams = paramsKey;
      props.onValidateVerificationCode({ token, verificationCode, policyNumber, email });
    }
  }
  render() {
    const { isAuthenticated, location } = this.props;
    const currentPath = location.pathname;
    const isLoginPage = currentPath === '/login' || currentPath === '/';
    const hasUrlParams = new URLSearchParams(location.search).has('token');
    const shouldHideLogin = isLoginPage && hasUrlParams && !isAuthenticated;

    return (
      <AppWrapper>
        <Helmet
          titleTemplate="Appsure FNOL"
          defaultTitle="Appsure FNOL"
        >
          <meta
            name="description"
            content="Appsure FNOL application"
          />
        </Helmet>
        <ProgressBar />

        {/* Show processing message during auto-validation */}
        {shouldHideLogin && (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <h3>Processing authentication...</h3>
            <p>Please wait while we validate your credentials and redirect you to the claim list.</p>
          </div>
        )}
        <Switch>
          <PrivateRoute
            path={routeConfig.claimList}
            component={ClaimListPage}
          />
          <PrivateRoute
            path={routeConfig.claimWizard}
            component={FastCoverWizardPage}
          />
          <PrivateRoute path="/claim-assessment/:claimId/:defaultTab" component={ClaimAssessment} />
          <Route exact path={routeConfig.login} component={LoginPage} />
          <Route exact path="/login" component={LoginPage} />
          <Route path={routeConfig.postSubmit} component={PostSubmit} />
          <Route path={routeConfig.postSubmitSCTI} component={PostSubmitSCTI} />
          <Route path="/summary/:token/:verifyCode/:policyNumber/:claimNumber" component={SummaryScreen} />
          <Route component={NotFoundPage} />
        </Switch>
        <Notification />
      </AppWrapper>
    );
  }
}

App.propTypes = {
  onValidateVerificationCode: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  location: PropTypes.object,
};

const mapStateToProps = (state) => {
  const isAuthenticated = state.get('global').get('isAuthenticated');
  return {
    isAuthenticated,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onValidateVerificationCode: (payload) => dispatch(validateVerificationCodeRequest(payload)),
});

const withSaga = injectSaga({ key: 'appSaga', saga: appSaga });

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withSaga(App)));



// WEBPACK FOOTER //
// ./app/containers/App/index.js